const loginAndSignUp = {
  loginTips: "Já tem uma conta de HitPaw? <1>Login</1>",
  loginSuccessTips: "Login com sucesso",
  loginErrorTips: "Login falhou",
  loginAccountOrPasswordErrorTips: "Seu endereço de e-mail ou senha é incorreta. Por favor, tente novamente.",
  loginAccountNotExitErrorTips: "O e-mail não foi registrado",
  signUpTips: "Ainda não é um usuário registrado?",
  rememberMe: "Lembre-se de mim",
  forgotPassword: "Esqueceu Senha?",
  forgotPasswordTitle: "Esqueceu Senha",
  verifyEmailBtn: "Verificar E-mail",
  resetPasswordTitle: "Redefinir senha",
  resetPasswordLabel: "Por favor, redefina sua senha",
  resetPasswordPlaceholder: "Digite uma nova senha",
  resetPasswordSuccessTips: "Senha redefinida com sucesso",
  signUpPrivacyTips: "Ao se registrar, você concorda com nossos <1>Serviços de Uso </1> e <3> Política de Privacidade</3>",
  loginPrivacyTips: "Ao fazer login, você concorda com nossos <1>Serviços de Uso</1> e <3>Política de Privacidade</3>",
  signUpSuccessTips: "Sua conta já foi registrada com sucesso!",
  getCode: "Obter Código",
  getCodeSuccessTips: "Código foi enviado para sua caixa de e-mail, por favor, verifique-o",
  verificationSuccessTips: "A verificação do endereço de e-mail foi aprovada",
  surveyTitle: "Bem-vindo ao HitPaw Online",
  surveyStep1: "<1>Etapa 1</1>/3",
  surveyStep2: "<1>Etapa 2</1>/3",
  surveyStep3: "<1>Etapa 3</1>/3",
  surveyQuestion: "Qual é o seu propósito com HitPaw?",
  surveyThemeQuestion: "Escolha um modelo de que você gosta",
  surveyAnswerOther: "Outros",
  surveyAnswer1: "Vídeo Diário",
  surveyAnswer2: "Vídeo Comercial",
  surveyAnswer3: "Vídeo Empresarial",
  surveyAnswer4: "Vídeo de Marketing",
  surveyAnswer5: "Vídeo de Mídia Social",
  surveyAnswer6: "Vídeo de Apresentação",
  surveyAnswer7: "Ferramenta de Vídeo",
  surveyAnswer8: "Vídeo de Viagem",
  surveyAnswer9: "Vídeo de Casamento",
  surveyAnswer10: "Vídeo de Aniversário",
  surveyAnswer11: "Vídeo de Bebê",
  surveyAnswer12: "Vídeo de Animal",
  surveyAnswer13: "Vídeo de Alimentos",
  surveyAnswer14: "Vídeo de Moda",
  surveyAnswer15: "Vídeo das Férias",
  surveyAnswer16: "Vídeo de Esporte",
  surveyAnswer17: "Vídeo de Fotos",
  surveyAnswer18: "Vídeo Musical",
  surveyAnswerLightMode: "Modo Claro",
  surveyAnswerDarkMode: "Modo Escuro",
  surveyNextBtn: "Continuar",
  surveyBackBtn: "Voltar",
  surveyDoneBtn: "Feito",
  surveyStartBtn: "Começar",
  logoutWarnTips: "Você tem certeza de que quer sair?",
  ContinuewithGoogle: 'Continuar com Google',
  Securityverification: 'Verificação da segurança',
  youraccount: 'Sua conta',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'já existe. Por favcor, verifique sua conta.',
};

export default loginAndSignUp;
